/* EUM (2026-10-30, INC-2026-00530): UN solo manejo del toque a un <video> con controles nativos, en TODA la tienda.
   En el celular el toque a esos controles sólo asoma su barra (ni llega `click`): clic muerto. La ficha lo arregló en
   media-gallery.js (#2852/#2858/#2928) y la portada tenía su propia copia (eum-home-vivo.js) que sólo quitaba el mudo:
   el 2º toque seguía muerto (5 de 7 dead_click tras #2928, reproducido en Chromium Android). Regla (la de la ficha):
   mudo → sonido · sonando → pausa · en pausa → reproduce con sonido (si el navegador lo niega, mudo). Se atiende UNA vez
   (`touchend` = el gesto en iPhone/Instagram; `pointerup` de respaldo a los 120 ms), no en la barra nativa (56 px de
   abajo) cuando se ve (en pausa o tocado hace < 3 s; 2026-10-31), no al deslizar (> 10 px). Con ratón, lo nativo (salvo en la galería de la ficha, como antes). Aviso ▶ ❚❚ 🔊. */
(function () {
  if (window.__eumVideoToque) return;
  window.__eumVideoToque = true;
  var x0 = 0, y0 = 0, t0 = 0, pendiente = 0, atendido = 0;
  function videoDe(el) {
    var v = el && el.closest && el.closest('video');
    return v && (v.controls || v.closest('.product__media-gallery-viewer')) ? v : null;
  }
  function aviso(v, icono) {
    var caja = v.parentElement;
    caja.setAttribute('data-eum-toque', icono); clearTimeout(caja.eumAviso);
    caja.eumAviso = setTimeout(function () { caja.removeAttribute('data-eum-toque'); }, 700);
  }
  function reproducir(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
  }
  function alToque(target, x, y) {
    clearTimeout(pendiente);
    var v = videoDe(target);
    if (!v || Date.now() - t0 > 600 || Date.now() - atendido < 500) return;
    if (Math.abs(x - x0) > 10 || Math.abs(y - y0) > 10) return;
    // La barra nativa (56 px de abajo) sólo se respeta si se VE: en pausa o tras un toque hace < 3 s. Sonando sin tocar
    // (autoplay mudo) la barra está oculta y el toque ahí sólo la asoma: era el dead_click que quedaba tras #2932.
    var ultimo = v.eumToque || 0; v.eumToque = Date.now();
    if (v.getBoundingClientRect().bottom - y < 56 && (v.paused || Date.now() - ultimo < 3000)) return;
    atendido = Date.now();
    if (!v.paused && v.muted) { v.muted = false; aviso(v, '🔊'); return; }
    if (!v.paused) { v.pause(); aviso(v, '❚❚'); return; }
    v.muted = false; reproducir(v); aviso(v, '▶');
    setTimeout(function () { if (v.paused) reproducir(v); }, 350);
  }
  document.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); }, true);
  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (t) alToque(e.target, t.clientX, t.clientY);
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType === 'touch') { pendiente = setTimeout(function () { alToque(e.target, e.clientX, e.clientY); }, 120); return; }
    if (e.target && e.target.closest && e.target.closest('.product__media-gallery-viewer')) alToque(e.target, e.clientX, e.clientY);
  }, true);
})();
